export { default, useLanguage, useLocales, useSetLocale } from "./LocaleProvider";
